import { SECOND_MS } from './time.ts';

// 1. Lowercase letter
// 2. Uppercase letter
// 3. Number
// 4. 8 characters
export const PASSWORD_TEXT_REQUIREMENTS =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;
export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 99;

export const POPUP_AUTH_ERRORS = {
  POPUP_CLOSED: 'POPUP_CLOSED',
  POPUP_FAILED_TO_OPEN: 'POPUP_FAILED_TO_OPEN',
  UNSUPPORTED: 'UNSUPPORTED',
  FAILED_INITIALIZATION: 'FAILED_INITIALIZATION',
  USER_CANCELLED: 'USER_CANCELLED',
  OPERATION_FAILED: 'OPERATION_FAILED',
} as const;

export type PopupAuthErrors =
  (typeof POPUP_AUTH_ERRORS)[keyof typeof POPUP_AUTH_ERRORS];

// The messages are for the thrown Error objects.
// They do not need to be translated as they are for engineers, not the public.
export const POPUP_AUTH_ERRORS_MESSAGES: Record<PopupAuthErrors, string> = {
  POPUP_CLOSED: 'Auth window was closed.',
  POPUP_FAILED_TO_OPEN: 'Auth window failed to open.',
  UNSUPPORTED: 'SSO login is unsupported for this workspace.',
  FAILED_INITIALIZATION: 'SSO object was not initialized.',
  USER_CANCELLED: 'User cancel the authentication.',
  OPERATION_FAILED: 'SSO login failed',
} as const;

export const DISCONNECT_ERRORS = {
  NO_SYNCED_ACCOUNT: 'NO_SYNCED_ACCOUNT',
  OPERATION_FAILED: 'OPERATION_FAILED',
} as const;

export type DisconnectErrors =
  (typeof DISCONNECT_ERRORS)[keyof typeof DISCONNECT_ERRORS];

// The messages are for the thrown Error objects.
// They do not need to be translated as they are for engineers, not the public.
export const DISCONNECT_ERRORS_MESSAGES: Record<DisconnectErrors, string> = {
  NO_SYNCED_ACCOUNT: 'No synced account found to delete',
  OPERATION_FAILED: 'Disconnect failed',
} as const;

export const ZOOM_OAUTH_URL = 'https://zoom.us/oauth/authorize';
export const ZOOM_OAUTH_DEFAULT_REDIRECT_PATH = '/zoom-onboarding';
export const ZOOM_APPS_SETTINGS_OAUTH_REDIRECT_PATH =
  '/setting/connected_apps?source=zoom';

export const DROPBOX_OAUTH_URL = 'https://www.dropbox.com/oauth2/authorize';
export const DROPBOX_APPS_SETTINGS_OAUTH_REDIRECT_PATH =
  '/setting/connected_apps?source=dropbox';

export const SALESFORCE_OAUTH_URL =
  'https://login.salesforce.com/services/oauth2/authorize';
export const SALESFORCE_APPS_SETTINGS_OAUTH_REDIRECT_PATH =
  '/setting/connected_apps?source=salesforce';

export const SLACK_OAUTH_URL = 'https://slack.com/oauth/v2/authorize';
export const SLACK_APPS_SETTINGS_OAUTH_REDIRECT_PATH =
  '/setting/connected_apps?source=slack';

export const HUBSPOT_OAUTH_URL = 'https://app.hubspot.com/oauth/authorize';
export const HUBSPOT_APPS_SETTINGS_OAUTH_REDIRECT_PATH =
  '/setting/connected_apps?source=hubspot';

export const APPS_SETTINGS_OAUTH_REDIRECT_SOURCE_PARAM = 'source';
export const APPS_SETTINGS_OAUTH_REDIRECT_SOURCE = {
  ZOOM: 'zoom',
  DROPBOX: 'dropbox',
  SALESFORCE: 'salesforce',
  MEMBER_SALESFORCE: 'membersalesforce',
  GOOGLE: 'google',
  SLACK: 'slack',
  HUBSPOT: 'hubspot',
} as const;
export const APPS_SETTINGS_OAUTH_REDIRECT_STATE_PARAM = 'state';

export const OAUTH_PROCESSING_STATE = {
  UNPROCESSED: 'UNPROCESSED',
  PROCESSING: 'PROCESSING',
  PROCESSED: 'PROCESSED',
} as const;

export type OAuthProcessingState =
  (typeof OAUTH_PROCESSING_STATE)[keyof typeof OAUTH_PROCESSING_STATE];

export const DESKTOP_OAUTH_URL_PARAMS_TO_CLEANUP = [
  'oauth_source',
  'oauth_code',
  'scope',
  'state',
  'error',
  'error_description',
] as const; // desktop oauth url params to cleanup

export const DESKTOP_OAUTH_TOAST_DURATION = 5 * SECOND_MS; // 5s for desktop oauth toast duration
